import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Fx, Stack } from 'Components';
import { DashboardContext } from 'Pages/Dashboard/DashboardContext';
import DashboardFilters from 'Pages/Dashboard/DashboardFilters/DashboardFilters';
import { DashboardFiltersValues } from 'Pages/Dashboard/Dashboard.types';
import { getAppRoutes } from 'Pages/App/App.constants';
import { UserActivity, Phishing, Elearning } from '.';

function ReportPage() {
	const [filterValues, setFilterValues] = useState<DashboardFiltersValues>({});
	const { pathname } = useLocation();
	const [hasProperties, setHasProperties] = useState(true);
    const appRoutes = getAppRoutes();

	const onDashboardFiltersChange = (value: DashboardFiltersValues) => {
		setFilterValues({ ...filterValues, ...value});
	};

    useEffect(() => {
		return () => setFilterValues({});
    }, [pathname]);

    if(window.location.host.includes("dev.") && appRoutes.PHISHING === pathname) return <Phishing />

    let component = null;
    if(appRoutes.USER_ACTIVITY === pathname) component = <UserActivity />
    else if(appRoutes.PHISHING === pathname) component = <Phishing />
    else if(appRoutes.TRAINING === pathname) component = <Elearning />

	return (
		<DashboardContext.Provider value={{ filters: filterValues, hasProperties }}>
			<Fx>
				<Fx column grow={1}>
					<Stack>
						<div>
							<Fx align="middle" justify="end">
								<DashboardFilters
									key={pathname}
									onChange={onDashboardFiltersChange}
									onSetHasProperties={setHasProperties}
								/>
							</Fx>
						</div>
                        {component}
					</Stack>
				</Fx>
			</Fx>
		</DashboardContext.Provider>
	);
}

export default ReportPage;